/* eslint-disable jsx-a11y/control-has-associated-label */
import { FlexWrapper } from 'Shared/FlexWrapper';
import { User } from '@centecomm/portal-service';
import { useCurrentUser } from '@centecomm/portal-service-react';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { QuestionCircle } from 'Icons/QuestionCircle';
import useSettingsFromState from 'State/Settings/Hooks/useSettingsFromState';
import { IconColors, SecondaryMenu } from '../../../../Icons';
import UserAvatar from './UserAvatar';
import UserPanel from './UserPanel';
import UserSummary from './UserSummary';
import styles from './navigation-account-row.module.css';

// TODO: Handle Notification Count
function NavigationAccountRow(): React.ReactElement {
    const { hasError: hasSettingsError, isLoaded: isSettingsFullyLoaded, settings } = useSettingsFromState();
    const { listen, push } = useHistory();
    const { currentUser } = useCurrentUser();

    const [panelIsOpen, togglePanelIsOpen] = useState<boolean>(false);

    const closePanelOnRouteChange = () => {
        togglePanelIsOpen(false);
    };

    useEffect(() => {
        const routeListener = listen(closePanelOnRouteChange);

        return routeListener;
    }, []);

    const handlePanel = () => {
        togglePanelIsOpen(!panelIsOpen);
    };

    const handleHelpButtonClick = () => {
        push('/product-documentation');
    };

    const { firstName = '', lastName = '', email = '' } = currentUser as User;

    return (
        <FlexWrapper align="center" justify="between" gap="0.5rem" className={styles.AccountRow}>
            <UserAvatar firstName={firstName} lastName={lastName} />
            <UserSummary name={`${firstName} ${lastName}`} email={email} />
            <div className={styles.RightActionButtons}>
                {!hasSettingsError && isSettingsFullyLoaded && settings?.helpGuides?.visible && (
                    <button type="button" onClick={handleHelpButtonClick} className={styles.QuestionButton}>
                        <QuestionCircle color={IconColors.LightGrey} viewBox="0 0 32 32" />
                    </button>
                )}
                <button type="button" onClick={handlePanel} data-qa="bottom-navigation-toggle-user-panel">
                    <SecondaryMenu color={IconColors.LightGrey} aspect="1.5rem" />
                </button>
            </div>
            {panelIsOpen && (
                <div className={styles.AccountRowPanel}>
                    <UserPanel />
                </div>
            )}
        </FlexWrapper>
    );
}

export default NavigationAccountRow;
